import { useState } from "react";
import axios from "axios";
import { Reveal, Kicker } from "@/components/Reveal";
import { IMAGES } from "@/content";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const JoinSection = ({ t }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/waitlist`, { email, name: name || null });
      setDone(true);
      toast.success(res.data.status === "already_joined" ? t.join.already : t.join.success);
    } catch {
      toast.error(t.join.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="join" data-testid="join-section" className="relative py-24 sm:py-32 px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.join} alt="" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0D0B0A] via-[#0D0B0A]/70 to-[#0D0B0A]" />
      </div>
      <div className="relative max-w-2xl mx-auto text-center">
        <Reveal>
          <Kicker>{t.join.kicker}</Kicker>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F4F0E6]">{t.join.title}</h2>
          <p className="text-base text-[#A8A294] mt-6 max-w-lg mx-auto leading-relaxed">{t.join.desc}</p>
        </Reveal>

        <Reveal delay={0.15}>
          {done ? (
            <p data-testid="waitlist-success" className="mt-10 font-heading italic text-2xl text-[#D4A373]">
              {t.join.success}
            </p>
          ) : (
            <form onSubmit={submit} data-testid="waitlist-form" className="mt-10 flex flex-col gap-4 max-w-md mx-auto">
              <input
                data-testid="waitlist-name-input"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={t.join.namePlaceholder}
                className="bg-transparent border-b border-[#F4F0E6]/20 rounded-none px-1 py-3 text-[#F4F0E6] placeholder:text-[#A8A294]/60 focus:border-[#D4A373] focus:outline-none transition-colors"
              />
              <input
                data-testid="waitlist-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t.join.placeholder}
                className="bg-transparent border-b border-[#F4F0E6]/20 rounded-none px-1 py-3 text-[#F4F0E6] placeholder:text-[#A8A294]/60 focus:border-[#D4A373] focus:outline-none transition-colors"
              />
              <button
                data-testid="waitlist-submit-button"
                type="submit"
                disabled={loading}
                className="mt-4 bg-[#D4A373] text-[#0D0B0A] rounded-full px-8 py-3.5 text-sm font-medium hover:bg-[#B87B41] transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
              >
                {loading && <Loader2 size={16} className="animate-spin" />}
                {t.join.button}
              </button>
            </form>
          )}
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-20 border-t border-[#F4F0E6]/10 pt-12">
            <h3 className="font-heading text-2xl sm:text-3xl text-[#F4F0E6]">{t.join.brochureTitle}</h3>
            <p className="text-sm text-[#A8A294] mt-3">{t.join.brochureDesc}</p>
            <a
              href={`${API}/brochure`}
              data-testid="brochure-download-button"
              className="inline-flex items-center gap-3 mt-8 border border-[#D4A373] text-[#D4A373] rounded-full px-8 py-3.5 text-sm font-medium hover:bg-[#D4A373] hover:text-[#0D0B0A] transition-colors"
            >
              <Download size={16} />
              {t.join.brochureBtn}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
